import { render, staticRenderFns } from "./EmployeeDetailModal.vue?vue&type=template&id=5119efce&scoped=true"
import script from "./EmployeeDetailModal.vue?vue&type=script&lang=js"
export * from "./EmployeeDetailModal.vue?vue&type=script&lang=js"
import style0 from "./EmployeeDetailModal.vue?vue&type=style&index=0&id=5119efce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5119efce",
  null
  
)

export default component.exports